module.exports = __webpack_public_path__ + "img/healthPro3.301f55b1.png";